<template>
    <div :class="$style.container">
        <div
            :class="$style.clickable_container"
            @click.prevent="emit('click')"
        >
            <IconButton
                interfaceTarget="close-game-mobile-button"
                size="m"
                color="carbon-400"
                icon="chevron-left"
                @click.stop="emit('closeGame')"
            />
            <Logo
                v-if="!props.hideBranding"
                mode="default"
                :class="$style.logo_override"
            />
        </div>
    </div>
</template>

<script lang="ts" setup>
import IconButton from '@/components/Buttons/IconButton.vue'
import Logo from '@/components/Logo.vue'

const emit = defineEmits<{
    closeGame: []
    click: []
}>()

const props = defineProps<{
    hideBranding?: boolean
}>()
</script>

<style module>
.container {
    padding-top: 8px;
    padding-right: 6px;
}
.clickable_container {
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 8px;
    background-color: var(--black);
    height: 160px;
    overflow: hidden;
}

.logo_override {
    position: absolute;
    transform: rotate(-90deg);
    height: 20px;
    top: 100px;
}
</style>
